import {
  InstantAnswerBuilderFn,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

export const PackageDimensionsAndWeight: InstantAnswerBuilderFn = (
  strictLocalize
) => ({
  titleBuilder: () =>
    packageDimensionsAndWeightBuilder(strictLocalize).getTitle(),
  descriptionBuilder: () =>
    packageDimensionsAndWeightBuilder(strictLocalize).getDescription(),
});

const packageDimensionsAndWeightBuilder = (
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () =>
      strictLocalize({
        defaultMessage: "Ship with Faire package restrictions",
        description: {
          text: "Title for the answer of package dimensions and weight issue",
        },
      }),
    getDescription: () => [
      strictLocalize({
        defaultMessage:
          "When you are using Ship with Faire, the carrier’s package weight and dimension restrictions apply. Read the Help Center articles we’ve found for you to understand your options or contact us for more help. You can also try using another carrier or choose Ship on your own.",
      }),
    ],
  };
};
